export default __webpack_public_path__ + "static/screen_2_07-bbc5ee4db183af48ad04d8110087d206.svg";